import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["disabled", "type", "data-testid", "data-disabled-reason"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TablerLoader2 = _resolveComponent("TablerLoader2")!
  const _component_TablerChevronDown = _resolveComponent("TablerChevronDown")!
  const _component_StudioTooltip = _resolveComponent("StudioTooltip")!

  return (_openBlock(), _createElementBlock("button", {
    ref: "buttonElement",
    class: _normalizeClass({
      'tw-flex tw-items-center tw-justify-center tw-font-medium focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-deep-orange-600': true,
      'dark:bg-white tw-bg-black tw-text-white hover:tw-bg-deep-orange-600 dark:tw-text-black dark:tw-ring-offset-black dark:hover:tw-text-white':
        _ctx.variant === 'filled' && !_ctx.disabled,
      'tw-border tw-text-black tw-outline-none hover:tw-border-deep-orange-50 hover:tw-bg-deep-orange-50 hover:tw-text-deep-orange-600 dark:tw-border-slate-800 dark:tw-text-white':
        _ctx.variant === 'outline' && !_ctx.disabled,
      'tw-border-transparent tw-text-black hover:tw-text-deep-orange-600 focus:tw-ring-deep-orange-600 dark:tw-text-white dark:hover:tw-text-deep-orange-500':
        _ctx.variant === 'text',
      'tw-border tw-border-rose-200 tw-text-rose-500 tw-outline-none hover:tw-border-rose-50 hover:tw-bg-rose-50 hover:tw-text-rose-600 focus:tw-ring-rose-500 dark:tw-border-rose-900 dark:tw-text-rose-200':
        _ctx.variant === 'warn' && !_ctx.disabled,
      '!tw-cursor-not-allowed tw-border tw-border-transparent !tw-bg-slate-200 !tw-text-slate-400 dark:!tw-bg-slate-400 dark:!tw-text-slate-200':
        _ctx.disabled,
      'hover:tw-border-inherit hover:tw-bg-inherit hover:tw-text-inherit dark:hover:tw-border-inherit dark:hover:tw-bg-inherit dark:hover:tw-text-inherit':
        _ctx.loading,
      'tw-h-8 tw-rounded-lg tw-px-3 tw-py-2 tw-text-xs': _ctx.size === 'base',
      'tw-h-6 tw-rounded-md tw-px-2 tw-text-2xs': _ctx.size === 'small'
    }),
    disabled: _ctx.disabled || _ctx.loading,
    type: _ctx.type,
    "data-testid": _ctx.trackingId,
    "data-disabled-reason": _ctx.disabled && _ctx.disabledReason ? _ctx.disabledReason : undefined,
    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showTooltip = true)),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showTooltip = false)),
    onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showTooltip = true)),
    onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showTooltip = false))
  }, [
    (_ctx.$slots.icon || _ctx.loading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass({
        'tw-flex tw-items-center tw-justify-center': true,
        '-tw-mx-[5px]': _ctx.size === 'small',
        '-tw-mx-[7px]': _ctx.size === 'base',
        '-tw-ml-1 tw-mr-1': _ctx.$slots.default,
        'tw-h-4 tw-w-4': _ctx.size === 'small',
        'tw-h-5 tw-w-5': _ctx.size === 'base'
      })
        }, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_TablerLoader2, {
                key: 0,
                class: "tw-animate-spin"
              }))
            : _renderSlot(_ctx.$slots, "icon", { key: 1 })
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.$slots.default)
      ? _renderSlot(_ctx.$slots, "default", { key: 1 })
      : _createCommentVNode("", true),
    (_ctx.dropdown)
      ? (_openBlock(), _createBlock(_component_TablerChevronDown, {
          key: 2,
          class: "-tw-mr-1 tw-ml-1 tw-h-3 tw-w-3"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_StudioTooltip, {
      show: _ctx.showTooltip,
      text: _ctx.disabledReason,
      targetElement: _ctx.$refs.buttonElement as Element
    }, null, 8, ["show", "text", "targetElement"])
  ], 42, _hoisted_1))
}